/* global axios */
import ApiClient from './ApiClient';

class WorkflowsAPI extends ApiClient {
  constructor() {
    super('workflows', { accountScoped: true });
  }

  // Lista por casa (kind: operational | marketing | social).
  list(params = {}) {
    return axios.get(this.url, { params });
  }

  clone(workflowId) {
    return axios.post(`${this.url}/${workflowId}/clone`);
  }

  toggle(workflowId) {
    return axios.post(`${this.url}/${workflowId}/toggle`);
  }

  test(workflowId) {
    return axios.post(`${this.url}/${workflowId}/test`);
  }

  versions(workflowId) {
    return axios.get(`${this.url}/${workflowId}/versions`);
  }

  // Tira UMA pessoa deste fluxo, com o motivo gravado.
  stopExecution(workflowId, executionId) {
    return axios.post(`${this.url}/${workflowId}/stop_execution`, {
      execution_id: executionId,
    });
  }

  // Segura UMA pessoa onde ela esta, sem tirar do fluxo.
  pauseExecution(workflowId, executionId) {
    return axios.post(`${this.url}/${workflowId}/pause_execution`, {
      execution_id: executionId,
    });
  }

  // Devolve ela pro fluxo, do mesmo ponto.
  resumeExecution(workflowId, executionId) {
    return axios.post(`${this.url}/${workflowId}/resume_execution`, {
      execution_id: executionId,
    });
  }

  // Tira todo mundo que esta dentro agora.
  stopAll(workflowId) {
    return axios.post(`${this.url}/${workflowId}/stop_all`);
  }

  // A conta ANTES de salvar: quem esta parado no fluxo, quem segue pelo desenho
  // novo e quem ficou sem lugar porque o passo foi apagado.
  editImpact(workflowId, nodes) {
    return axios.get(`${this.url}/${workflowId}/edit_impact`, {
      params: { nodes },
    });
  }

  versionSnapshot(workflowId, versionId) {
    return axios.get(`${this.url}/${workflowId}/version_snapshot`, {
      params: { version_id: versionId },
    });
  }

  // Fatia D: pina uma execucao como evento de trabalho (null = soltar).
  pin(workflowId, executionId) {
    return axios.post(`${this.url}/${workflowId}/pin`, {
      execution_id: executionId,
    });
  }

  // Fatia D: arma (ou cancela) a escuta do proximo evento real.
  capture(workflowId, { cancel = false } = {}) {
    return axios.post(`${this.url}/${workflowId}/capture`, { cancel });
  }

  // Simula o grafo da tela a partir de uma execucao. node_id = ensaiar um
  // unico passo; stopAt = play em cima de um no (roda do gatilho ate ele).
  simulate(
    workflowId,
    { executionId = null, nodes, edges, nodeId = null, stopAt = null }
  ) {
    return axios.post(`${this.url}/${workflowId}/simulate`, {
      execution_id: executionId,
      nodes,
      edges,
      node_id: nodeId,
      stop_at: stopAt,
    });
  }

  // Gatilho "agenda": roda agora, sem esperar o horario.
  runSchedule(workflowId) {
    return axios.post(`${this.url}/${workflowId}/run_schedule`);
  }

  // Fatia F: gera/regenera URL + segredo do gatilho webhook.
  webhookCredentials(workflowId, { regenerate = false } = {}) {
    return axios.post(`${this.url}/${workflowId}/webhook_credentials`, {
      regenerate: regenerate || undefined,
    });
  }

  executions(workflowId, params = {}) {
    return axios.get(`${this.url}/${workflowId}/executions`, { params });
  }

  availableConfig() {
    return axios.get(`${this.url}/available_config`);
  }

  // Destinos das ações "Mensagem para contato/grupo" ({ inbox_id, kind, q }).
  messageTargets(params) {
    return axios.get(`${this.url}/message_targets`, { params });
  }

  testCondition(payload) {
    return axios.post(`${this.url}/test_condition`, payload);
  }
}

export default new WorkflowsAPI();
